import { AddBillAutomaticAddSuggestionModal } from "@features/AddBillAutomaticAddSuggestionModal/AddBillAutomaticAddSuggestionModal";
import { AddBillModal } from "@features/AddBillModal/AddBillModal";
import { AddBillVariantSelectorModal } from "@features/AddBillVariantSelectorModal/AddBillVariantSelectorModal";
import { useModalActions } from "@store/modal/modal";
import { usePOAStatementConsentsStateQuery } from "@services/powersOfAttorney/queries";
import { useFeatureConfig } from "./useFeatureFlags";
import { usePOAModal } from "./usePOAModal";

export const useAddBillModal = () => {
  const { create } = useModalActions();
  const { isBillVariantSelectorEnabled, isPoaEnabled } = useFeatureConfig();
  const { openPOAModal } = usePOAModal();

  const { data: powerOfAttorneyConsent } =
    usePOAStatementConsentsStateQuery(isPoaEnabled);

  const openAddBillModal = (options?: {
    preselectedJointBillServiceId?: number;
    shouldSuggestAutomaticPoa?: boolean;
    preselectedCategoryId?: string;
  }) => {
    if (isBillVariantSelectorEnabled) {
      if (
        options?.shouldSuggestAutomaticPoa &&
        isPoaEnabled &&
        powerOfAttorneyConsent?.activeConsentsExist
      ) {
        create((modalProps) => (
          <AddBillAutomaticAddSuggestionModal
            {...modalProps}
            onSelect={(automaic) => {
              if (automaic) {
                openPOAModal({ shouldFetchAllRecommendations: true });
              } else {
                create((modalProps) => (
                  <AddBillVariantSelectorModal {...modalProps} />
                ));
              }
            }}
          />
        ));

        return;
      }

      create((modalProps) => <AddBillVariantSelectorModal {...modalProps} />);
      return;
    }

    create((modalProps) => (
      <AddBillModal
        {...modalProps}
        preselectedJointBillServiceId={options?.preselectedJointBillServiceId}
        preselectedCategoryId={options?.preselectedCategoryId}
      />
    ));
  };

  return { openAddBillModal };
};
